module.exports = __webpack_public_path__ + "img/yandex.a0af3926.svg";